import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/"); return; }
    const session_id = match[1];
    (async () => {
      try {
        await api.post("/auth/session", { session_id }, { withCredentials: true });
        await refresh();
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-nova-bg text-nova-mute">
      <div className="mono-label">Signing you in…</div>
    </div>
  );
}
